<template>
  <div class="leo2-news">
    <div class="okzhuan-news">
      <div class="okzhuan-news-title">
        资讯动态
      </div>
    </div>
    <div style="height: 10px;"></div>
    <div class="content-title">
      <div :class="{'active':active==0}" @click="tabActive(0)">全部</div>
      <div :class="{'active':active==1}" @click="tabActive(1)">行业新闻</div>
      <div :class="{'active':active==2}" @click="tabActive(2)">游好赚动态</div>
    </div>
    <a class="okzhuan-news-list" @click="toStat(l.Id)" :href="'/news/detail/'+l.Id" v-for="(l,index) in list" :key="index" :class="{'okzhuan-news-list2':l.Type === '1'}">
      <div class="img" :class="{'no':!l.Img}">
        <img :src="l.Img" v-if="l.Img" />
        <img src="/static/images/no.png" v-else />
      </div>
      <div class="con">
        <div class="title">{{l.Title}}</div>
        <p>{{l.Summary}}</p>
      </div>
      <div class="time">
        <div class="month">{{l.Date}}</div>
        <p>{{l.Year}}</p>
      </div>
    </a>
    <pagination :total="total" :current-page='current' @pagechange="changePage"></pagination>
  </div>
</template>

<script>
import pagination from '@/components/pagination'
export default {
  name: "news",
  components: {
    pagination
  },
  data() {
    return {
      list: [],
      total: 0,  // 记录总条数
      display: 10,  // 每页显示条数
      current: 1, // 当前的页码数
      active: 0
    }
  },
  mounted() {
    document.title = '资讯动态-游好赚';
    document.querySelector('meta[name="description"]').setAttribute('content', '');
    document.querySelector('meta[name="keywords"]').setAttribute('content', '');
    if (this.$route.query.type) {
      this.active = Number(this.$route.query.type);
    }
    if (this.$route.query.page) {
      this.current = Number(this.$route.query.page);
      this.loadData(Number(this.$route.query.page));
    } else {
      this.loadData(1);
    }
  },
  methods: {
    goPage(id) {
      // 下面的写法也可以
      this.$router.push({
        name: `detail`,
        params: {
          id: id
        }
      })
    },
    tabActive(active) {
      this.active = active;
      this.loadData(1);
      window.history.replaceState({}, 0, '//' + window.location.host + '/news?type=' + this.active);
    },
    changePage(page) {
      var url = '//' + window.location.host + '/news?page=' + page;
      if (this.active) {
        url += '&type=' + this.active;
      }
      window.history.replaceState({}, 0, url);
      this.loadData(page);
    },
    loadData(page) {
      this.axios.news({
        Page: page,
        newsType: this.active
      }).then(res => {
        if (res.data.code === 0) {
          this.total = res.data.data.total
          if (res.data.data.rows.length > 0) {
            this.list = res.data.data.rows
          } else {
            this.list = []
          }
        } else {
          this.list = []
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .leo2-news {
    background:#ffffff;
    overflow: hidden;
    .okzhuan-news {
      width: 100%;
      height: 390px;
      clear: both;
      background: url("../../assets/images/banner_news.png") no-repeat center top;

      .okzhuan-news-title {
        width: 1080px;
        height: 390px;
        line-height: 390px;
        margin: 0 auto;
        font-size: 40px;
        color: white;
        font-weight: bold;
      }
    }
    .content-title{
      width: 1050px;
      margin: 0 auto;
      display: flex;
      margin-top: 30px;
      div{
        padding: 0 15px;
        height: 32px;
        border-radius: 4px;
        font-size: 16px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:first-child{
          margin-left: -12px;
        }
        &.active{
          background: #FF5000;
          color: #FFFFFF;
        }
      }
    }
    .okzhuan-news-list {
      width: 1050px;
      height: 125px;
      margin: 0 auto 0;
      margin-top: 30px;
      clear: both;
      padding: 30px;
      padding-right: 0;
      display: block;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px; //将颜色提到前面，且将h-shadow,v-shadow设为0px,实现四周阴影
      background: url("../../assets/images/label_official.png") no-repeat right top;
      border-radius: 10px;
      .img {
        width: 185px;
        height: 125px;
        margin-right: 30px;
        float: left;
        background-color: #eeeeee;
        &.no{
          display: flex;
          align-items: center;
          justify-content: center;
          img{
            width: 102px;
            height: 55px;
          }
        }

        img {
          width: 100%;
          height: 100%;
          vertical-align: middle;
          cursor: pointer;
        }
      }

      .con {
        width: 520px;
        float: left;
        margin-right: 80px;

        .title {
          font-size: 24px;
          color: #333;
          cursor: pointer;
        }

        p {
          font-size: 16px;
          color: #999;
          line-height: 24px;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
        }
      }

      .time {
        width: 216px;
        height: 125px;
        float: right;
        text-align: center;
        border-left: 1px solid #f1f1f1;

        .month {
          color: #333;
          font-size: 24px;
          padding-top: 45px;
        }

        p {
          font-size: 16px;
          color: #999;
          margin-top: 3px;
        }
      }
    }

    .okzhuan-news-list2 {
      background: url("../../assets/images/label_news.png") no-repeat right top;
    }
  }
</style>
